var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.23093 8.99984L1.03462 2.80353C0.54575 2.31466 0.54575 1.52204 1.03462 1.03316C1.5235 0.544285 2.31612 0.544285 2.805 1.03316L9.0013 7.22946L15.1976 1.03316C15.6865 0.544285 16.4791 0.544285 16.968 1.03316C17.4569 1.52204 17.4569 2.31466 16.968 2.80353L10.7717 8.99984L16.968 15.1961C17.4569 15.685 17.4569 16.4776 16.968 16.9665C16.4791 17.4554 15.6865 17.4554 15.1976 16.9665L9.0013 10.7702L2.805 16.9665C2.31612 17.4554 1.5235 17.4554 1.03462 16.9665C0.54575 16.4776 0.54575 15.685 1.03462 15.1961L7.23093 8.99984Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.21802949.svg";
export { ForwardRef as ReactComponent };